"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemLabelToJSON = exports.MenuItemLabelFromJSONTyped = exports.MenuItemLabelFromJSON = void 0;
function MenuItemLabelFromJSON(json) {
    return MenuItemLabelFromJSONTyped(json, false);
}
exports.MenuItemLabelFromJSON = MenuItemLabelFromJSON;
function MenuItemLabelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'key': json['key'],
        'name': json['name'],
    };
}
exports.MenuItemLabelFromJSONTyped = MenuItemLabelFromJSONTyped;
function MenuItemLabelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'key': value.key,
        'name': value.name,
    };
}
exports.MenuItemLabelToJSON = MenuItemLabelToJSON;
